{
    "MainmenuPinmenu": "Pin Menu",
    "MainmenuPinnedmenu": "Unpin Menu",
    "MainmenuHome": "Home",
    "MainmenuMoreoptions": "More options",
    "MainmenuWhatisnew": "What's New?",
    "MainmenuOmnichannelPanel": "Omnichannel Panel",
    "MainmenuPrivacynotice": "Privacy Notice",
    "MainMenuCookiePolicy": "Cookie Policy",
    "MainmenuTermsofservice": "Terms of Service",
    "MainmenuSetlanguage": "Set Language",
    "MainmenuHelp": "Help",
    "MainmenuChangePassword": "Change Password",
    "MainmenuServerInfo": "Server Info",
    "MainmenuSendfeedback": "Send us your feedback!",
    "MainMenu_RestartTour": "Restart the tour",
  "MainMenu_Timezone": "Change Timezone",
    "MainmenuButtonTitleAddreport": "Add New Report",
    "MainmenuButtonTitleDeletereport": "Delete Report",
    "MainmenuButtonTitlePermanentlyDeletereport": "Permanently Delete Report",
    "MainmenuButtonSubTitleDisabled": "(Select some reports to use this option)",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Clear Content Cache",
    "NAME": "LanguageMainMenu",
    "MainMenu_Turn_On_Insights_Hub": "Turn On Insights Dashboard",
    "MainMenu_Turn_Off_Insights_Hub": "Turn Off Insights Dashboard"
}